import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconRadiusBottomLeft12 from './IconRadiusBottomLeft12';
import IconRadiusBottomLeft16 from './IconRadiusBottomLeft16';
import IconRadiusBottomLeft20 from './IconRadiusBottomLeft20';
import IconRadiusBottomLeft24 from './IconRadiusBottomLeft24';
import IconRadiusBottomLeft32 from './IconRadiusBottomLeft32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconRadiusBottomLeft = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconRadiusBottomLeft12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconRadiusBottomLeft16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconRadiusBottomLeft20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconRadiusBottomLeft24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconRadiusBottomLeft32 {...props} />}
        </span>
    );
};
IconRadiusBottomLeft.displayName = 'FondueIconRadiusBottomLeft';

export default memo(IconRadiusBottomLeft);
